
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.364 12.262c-.185.19-.463.3-.756.3s-.57-.11-.755-.3L.33 8.72a.732.732 0 01-.221-.57.768.768 0 01.305-.543c.18-.142.419-.221.666-.22h1.364V1.31c0-.23.186-.417.417-.417h3.51c.23 0 .416.187.416.417v6.08H8.14c.246 0 .483.08.662.221a.77.77 0 01.303.54.731.731 0 01-.219.57l-3.522 3.541z","fill":"currentColor"}})])
          )
        }
      }
    